import { render, staticRenderFns } from "./ModuloConsultorio.vue?vue&type=template&id=a6a6c8e0&scoped=true&"
import script from "./ModuloConsultorio.vue?vue&type=script&lang=js&"
export * from "./ModuloConsultorio.vue?vue&type=script&lang=js&"
import style0 from "./ModuloConsultorio.vue?vue&type=style&index=0&id=a6a6c8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a6c8e0",
  null
  
)

export default component.exports